module.exports = __webpack_public_path__ + "img/2-5-2.3bf304cf.png";